import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { WebAccessControlSchedulerFormController } from '../controller/WebAccessControlSchedulerFormController';
import { ScheduleItem } from '../../webAccessControlSchedulerApp/types';

export class WebAccessControlSchedulerFormComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: WebAccessControlSchedulerFormController,
    });
  }

  static override get observedAttributes(): string[] {
    return [...BaseWebComponentElement.observedAttributes, 'data-scheduler'];
  }

  get isVisible(): boolean | undefined {
    if (this.hasAttribute('data-is-visible')) {
      const value = this.getAttribute('data-is-visible');
      return value ? JSON.parse(value) : undefined;
    }
    return undefined;
  }

  set isVisible(value: boolean | undefined) {
    if (value) {
      this.setAttribute('data-is-visible', '');
    } else {
      this.removeAttribute('data-is-visible');
    }
  }

  set schedule(value: ScheduleItem | undefined) {
    if (typeof value === 'undefined') {
      this.removeAttribute('data-schedule');
    } else {
      this.setAttribute('data-schedule', JSON.stringify(value));
    }
  }

  get schedule(): ScheduleItem | undefined {
    if (this.hasAttribute('data-schedule')) {
      const value = this.getAttribute('data-schedule');
      return value ? JSON.parse(value) : undefined;
    }
    return undefined;
  }

}
